const clickOutside = {
  mounted(el, binding) {
    el.__clickOutsideHandler = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };
    document.addEventListener("click", el.__clickOutsideHandler);
  },
  unmounted(el) {
    document.removeEventListener("click", el.__clickOutsideHandler);
    delete el.__clickOutsideHandler;
  },
};

export default clickOutside;
